import Image from "next/image";

import { useStore } from "@hooks/useZustandProvider";
import emptyCmsPageSvg from "@images/svg/empty-cms-page.svg";
import Button from "@ui-kit/Button/Button";

import s from "./EmptyPage.module.scss";

const EmptyPage = ({ openPageStrucrute }) => {
  const { cms } = useStore();
  const { isPageNotFound } = cms.page;
  return (
    <div className={s.empty}>
      <Image src={emptyCmsPageSvg} alt="" />
      <h3>This page is empty</h3>
      <p>Add sections from the page structure menu to create content.</p>
      <Button onClick={openPageStrucrute} text="go to sections" />
    </div>
  );
};

export default EmptyPage;
